import React, { useState } from 'react';
import logo from '../../images/edu_logo.png';
import NavLinks from './NavLinks';
import SideBarMobile from './SideBarMobile';

const NavBar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <>
      <nav className="fixed top-0 w-full bg-white shadow-md z-50">
        <div className="flex justify-between items-center py-3 px-4 md:px-12">
          <img alt="Logo" className="h-[50px] w-[220px]" src={logo} />

          {/* Burger menu for mobile */}
          <div className="lg:hidden">
            <button onClick={() => setIsSidebarOpen(true)} className="text-blue-900 focus:outline-none">
              <svg className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <NavLinks />
          </div>
        </div>
      </nav>

      {/* Mobile Sidebar */}
      {isSidebarOpen && <SideBarMobile closeSidebar={() => setIsSidebarOpen(false)} />}
    </>
  );
};

export default NavBar;
